<!--
	作者：1764635606@qq.com
	时间：2018-09-07
	描述：数值输入范围
-->

<template>
    <div class="number-range-input">
        <BPInput
            @on-blur="minBlur"
            class="min-input"
            type="number"
            v-model="value.min"
            :floatLength="floatLength"
            :disabled="disabled"
            :placeholder="minPlaceholder"></BPInput>
        -
        <BPInput
            @on-blur="maxBlur"
            class="max-input"
            type="number"
            v-model="value.max"
            :floatLength="floatLength"
            :disabled="disabled"
            :placeholder="maxPlaceholder"></BPInput>
    </div>
</template>

<script>
    import {check} from '@/utils'
    
    export default {
        props: {
            value: {
                type: Object,
                default () {
                    return {min: '', max: ''}
                }
            },
            minPlaceholder: {
                type: String,
                default: '请输入最小值'
            },
            maxPlaceholder: {
                type: String,
                default: '请输入最大值'
            },
            disabled: {
                type: Boolean,
                default: false
            },
            floatLength: {
                type: Number,
                defualt: -1
            }
        },
        data () {
            return {
                oldMin: '',
                oldMax: ''
            }
        },
        methods: {
            minBlur () {
                if (check.isNull(this.value.min) || check.isNull(this.value.max)) {
                    return
                }
                if (Number(this.value.min) > Number(this.value.max)) {
                    this.value.min = this.oldMin
                    this.$Message.error('最大值不能小于最小值')
                } else {
                    this.oldMin = this.value.min
                    this.oldMax = this.value.max
                }
                this.$emit('on-change', Object.assign({}, this.value))
            },
            maxBlur () {
                if (check.isNull(this.value.min) || check.isNull(this.value.max)) {
                    return
                }
                if (Number(this.value.min) > Number(this.value.max)) {
                    this.value.max = this.oldMax
                    this.$Message.error('最大值不能小于最小值')
                } else {
                    this.oldMin = this.value.min
                    this.oldMax = this.value.max
                }
                this.$emit('on-change', Object.assign({}, this.value))
            }
        }
    }
</script>

<style lang="less" scoped>
    .number-range-input{
        .min-input, .max-input{
            width: 140px;
        }
        .min-input{
            margin-right: 2px;
        }
        .max-input{
            margin-left: 2px;
        }
    }
</style>